import React, { useContext } from 'react';
import { ThemeContext } from '../../hooks/ThemeContext';

const Card = ({ children, className = '', hover = true, padding = 'p-6' }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  const baseStyles = isDark
    ? 'bg-[#0b0b0c] border border-white/6'
    : 'bg-white/95 border border-gray-100';

  const hoverStyles = hover
    ? isDark
      ? 'hover:border-white/12 transition-all'
      : 'hover:shadow-md transition-all'
    : '';

  return (
    <div className={`${baseStyles} ${hoverStyles} ${padding} rounded-lg shadow-sm ${className}`}>
      {children}
    </div>
  );
};

export default Card;
